//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import VueBetterScroll from 'vue2-better-scroll'
  import jquery from 'jquery'
  export default {
  components: { VueBetterScroll },
    props: {
      height: Number, // 直接填写滚动窗高度
      unnecessaryHeight: Number, // 根据浏览器窗口，扣除该参数高度
      page: Object,
      autoLoad:{
        type: Boolean,
        default: true,
        required: false
      },
    },
    watch:{
      height(val){
        this.computeScrollerHeight()
      },
      unnecessaryHeight(val){
        this.computeScrollerHeight()
      }
    },
    data () {
      return {
        scrollerHeight: 0,
        // 这个配置可以开启滚动条，默认为 false。当设置为 true 或者是一个 Object 的时候，都会开启滚动条，默认是会 fade 的
        scrollbarObj: {
          fade: true
        },
        // 这个配置用于做下拉刷新功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启下拉刷新，可以配置顶部下拉的距离（threshold） 来决定刷新时机以及回弹停留的距离（stop）
        pullDownRefreshObj: {
          threshold: 50,
          stop: 40
        },
        // 这个配置用于做上拉加载功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启上拉加载，可以配置离底部距离阈值（threshold）来决定开始加载的时机
        pullUpLoadObj: {
          threshold: 0,
          txt: {
            more: '加载更多',
            noMore: '没有更多数据了'
          }
        },
        startY: 0,  // 纵轴方向初始化位置
        scrollToX: 0,
        scrollToY: 0,
        scrollToTime: 700,
        items: []
      }
    },
    mounted () {
      if(this.autoLoad !== false){
        this.onPullingDown()
      }
    },
    methods: {
      computeScrollerHeight(){
        if(this.height){
          this.scrollerHeight = this.height
        }else if(this.unnecessaryHeight){
          this.scrollerHeight = jquery(document.body).height() - this.unnecessaryHeight
        }
        this.scrollUpdate()
      },
      // 滚动到页面顶部
      scrollTo () {
        this.computeScrollerHeight()
        this.$refs.scroll.scrollTo(this.scrollToX, this.scrollToY, this.scrollToTime)
      },
      onPullingDown () {
        this.computeScrollerHeight()
        // 模拟下拉刷新
        this.$emit('getData',0)
        // console.log('下拉刷新')
      },
      onPullingUp () {
        this.computeScrollerHeight()
        // 模拟上拉 加载更多数据
        this.$emit('getData')
        // console.log('上拉加载')
      },
 
      // 设置滚动条位置
      // scrollToY(y){
      //   this.$refs.scroll.scrollTo(y)
      // },
      // 根据page更新翻页状态
      scrollUpdate () {
        if(this.page.curIndex < this.page.lastIndex){
          this.$refs.scroll.forceUpdate(true)
        }else{
          this.$refs.scroll.forceUpdate(false)
        }
        // if(this.page.curIndex == 1){
        //   this.$refs.scroll.scrollTo(0,0,0)
        // }
      },
    },
    activated:function(){
      this.computeScrollerHeight()
    }
    // created(){
    //   console.log(this.page)
    // }
  }



// WEBPACK FOOTER //
// ./src/common/components/SaafScroller.vue